import { render, staticRenderFns } from "./AsyncSidebar.vue?vue&type=template&id=4e403c6e&scoped=true&"
import script from "./AsyncSidebar.vue?vue&type=script&lang=js&"
export * from "./AsyncSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AsyncSidebar.vue?vue&type=style&index=0&id=4e403c6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e403c6e",
  null
  
)

export default component.exports